import { C, SectionLabel, H2, wrap, useIsMobile } from '../styles';

// The mechanism behind the under-72-hour turnaround: material pricing is
// in-house rather than quoted back by a third party. The steel supply business
// is deliberately not named here, and neither is any individual — see the
// relaunch brief, Task 4. Do not restore the "paid by the manufacturer" line.
const points = [
  { t: 'Material priced in-house', b: 'No third-party quote to wait on before your project moves.' },
  { t: 'Quotes in under 72 hours', b: 'Because the slowest step in most quotes has been removed.' },
  { t: 'Accurate, not padded', b: 'You get the real price for your agreed specs — no markups added on top.' },
];

export default function SteelSupply() {
  const isMobile = useIsMobile();
  return (
    <section id="steel" style={{ padding: isMobile ? '64px 0' : '88px 0', borderTop: `1px solid ${C.bdr}`, background: C.surf2 }}>
      <div style={wrap}>
        <SectionLabel orange>In-house material</SectionLabel>
        <H2 style={{ maxWidth: 720, marginBottom: 18 }}>We don't wait on a steel quote. We are the steel quote.</H2>
        <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.75, maxWidth: 560, marginBottom: 16 }}>
          Most sourcing services have to go and ask what the material costs before they can tell you anything. We don't — our own Toronto steel supply means material pricing is in-house and immediate.
        </p>
        <p style={{ color: C.mut, fontSize: 16, lineHeight: 1.75, maxWidth: 560, marginBottom: isMobile ? 32 : 44 }}>
          That's the whole reason we can turn a quote around in under 72 hours instead of a fortnight — and it's why the numbers you get back are real numbers, not a placeholder someone revises after they've checked with a supplier.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: 14 }}>
          {points.map((p) => (
            <div key={p.t} style={{
              background: C.surf, border: `1px solid ${C.bdr}`, borderRadius: 10, padding: 24,
              transition: 'border-color 0.2s',
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor = C.orange}
              onMouseLeave={e => e.currentTarget.style.borderColor = C.bdr}
            >
              <div style={{ width: 24, height: 2, background: C.orange, marginBottom: 12 }} />
              <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 21, fontWeight: 700, textTransform: 'uppercase', color: C.txt, marginBottom: 8 }}>{p.t}</h3>
              <p style={{ fontSize: 13, color: C.mut, lineHeight: 1.7 }}>{p.b}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
